module.exports = __webpack_public_path__ + "img/me.144e25db.svg";